import { useEffect, useState } from "react";

export default function EmployeeCodePromptDialog({
  open = false,
  darkMode = false,
  acting = false,
  title = "Set employee code",
  description = "No automated employee code structure is active. Enter the employee code to use when creating this employee.",
  confirmLabel = "Create employee",
  onCancel,
  onConfirm,
}) {
  const [code, setCode] = useState("");

  useEffect(() => {
    if (!open) setCode("");
  }, [open]);

  if (!open) return null;

  const inputClass = darkMode
    ? "mt-1 w-full rounded-md border border-[#3C3C4C] bg-[#1D1D1D] px-2 py-1.5 text-xs text-gray-100"
    : "mt-1 w-full rounded-md border border-gray-300 bg-gray-50 px-2 py-1.5 text-xs text-gray-900";

  return (
    <div className="fixed inset-0 z-[10050] flex items-center justify-center bg-black/60 p-4">
      <div
        className={`w-full max-w-sm rounded-lg border p-4 shadow-xl ${
          darkMode ? "border-[#3C3C4C] bg-[#1a1a1a]" : "border-gray-200 bg-white"
        }`}
      >
        <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">{title}</h4>
        <p className="mt-1 text-[11px] text-gray-600 dark:text-gray-400">{description}</p>
        <label className="mt-3 block text-xs text-gray-700 dark:text-gray-300">
          Employee code
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className={inputClass}
            placeholder="e.g. 005210"
            autoFocus
            maxLength={32}
          />
        </label>
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={acting}
            className="rounded-md border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 dark:border-[#3C3C4C] dark:text-gray-200"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(code.trim())}
            disabled={acting}
            className="rounded-md bg-redhalo-red px-3 py-1.5 text-xs font-medium text-white disabled:opacity-50"
          >
            {acting ? "Creating…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
